module.exports = __webpack_public_path__ + "static/media/Middle_Second_Building_Dark.034e4cc8.png";